
<template>
  <DanhSachGroup />
</template>

<script>
import DanhSachGroup from "@/components/pages/quan-tri-he-thong/group/DanhSachGroup.vue";
import { setBreadcrumb } from "@/utils/commonUtils";
import { MENU_ROUTE_NAME } from "@/constants/constants";

export default {
  name: "TrangDanhSachGroup",
  components: {
    DanhSachGroup
  },
  created() {
    setBreadcrumb(
      `${
        MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.GROUP.NAME
      }`
    );
  }
};
</script>


